export default __webpack_public_path__ + "static/media/measure2.b68adbb2.png";